document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".mega-menu").forEach(menu => {

    const categories = menu.querySelectorAll(".mega-category");
    const groups = menu.querySelectorAll(".mega-group");

    function activate(index) {
      categories.forEach(el => el.classList.remove("active"));
      groups.forEach(el => el.classList.remove("active"));

      if (categories[index]) categories[index].classList.add("active");
      if (groups[index]) groups[index].classList.add("active");
    }

    // default active (first)
    if (categories.length > 0) {
      activate(0);
    }

    categories.forEach((cat, index) => {
      cat.addEventListener("mouseenter", function () {
        activate(index);
      });
    });

  });

});